module.exports = __webpack_public_path__ + "img/2.7ac8df50.svg";